module.exports = __webpack_public_path__ + "img/animals_02_H.abb91b59.webp";